import React from "react";

const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_impulse-ai-launch/artifacts/fn64cs2m_Nova%20logo7.png";

/**
 * Seven Impulse mark — official lightning bolt with integrated "7".
 */
export const Logo = ({ size = 28, className = "", showWord = true }) => {
  return (
    <div
      className={`flex items-center gap-2.5 ${className}`}
      data-testid="seven-impulse-logo"
    >
      <img
        src={LOGO_SRC}
        alt="Seven Impulse"
        width={size}
        height={size}
        style={{ width: size, height: size }}
        className="block object-contain select-none"
        draggable={false}
      />
      {showWord && (
        <span
          className="text-[15px] tracking-[-0.01em] font-medium text-[#F5F1E8]"
          style={{ fontFamily: '"Space Grotesk", sans-serif' }}
        >
          Seven Impulse
        </span>
      )}
    </div>
  );
};

export default Logo;
